/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.info\":[\"Ympyrä, jonka sisällä on i-kirjain\"]}");